import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/agreements/addendums/loading';
import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';

export const Route = createFileRoute('/_private/agreements/_template/$id/addendum')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: false,
    pageTitle: 'Addendums',
    tabKey: 'agreement/addendum',
  },
  pendingComponent: Loading,
});
